import React from 'react';
export default function PageNotFound() {
  return (
    <div>
      <h1>Error al ingresar el link</h1>
    </div>
  );
}
